export enum UserEventFilterType {
  UTWORZENIE_KONTA = 'Utworzenie konta',
  MODYFIKACJA_DANYCH = 'Modyfikacja danych',
  ZALOGOWANIE = 'Zalogowanie',
  WYLOGOWANIE = 'Wylogowanie',
  ZABLOKOWANIE_UZYTKOWNIKA = 'Zablokowanie',
  ODBLOKOWANIE_UZYTKOWNIKA = 'Odblokowanie',
  NADANIE_PRAWA_ADMINA = 'Nadanie prawa admina',
  ODEBRANIE_PRAWA_ADMINA = 'Odebranie prawa admina',
  ODCZYTANIE_KOMUNIKATU = 'Odczytanie komunikatu',
  ZATWIERDZENIE_REGULAMINU = 'Zatwierdzenie regulaminu',
  USUNIECIE_Z_ORGANIZACJI = 'Usunięcie z organizacji',
  DODANIE_UPRAWNIEN_W_ORGANIZACJI = 'Dodanie uprawnień w organizacji',
  USUNIECIE_UPRAWNIEN_W_ORGANIZACJI = 'Usunięcie uprawnień w organizacji',
  MODYFIKACJA_UPRAWNIEN_W_ORGANIZACJI = 'Modyfikacja uprawnień w organizacji',
  DODANIE_CZLONKA_RODZINY = 'Dodanie członka rodziny',
  USUNIECIE_CZLONKA_RODZINY = 'Usunięcie członka rodziny',
  WYSLANIE_WNIOSKU = 'Wysłanie wniosku',
  ZAPIS_ZMODYFIKOWANEGO_DOKUMENTU_ROBOCZEGO = 'Zapis wniosku roboczego',
  REZYGNACJA_Z_WNIOSKU = 'Rezygnacja z wniosku',
  ZAPROSZENIE_DO_ZARZADZANIA_ORGANIZACJA = 'Zaproszenie do zarządzania organizacją',
  PRZYJECIE_ZAPROSZENIA_DO_ZARZADZANIA_ORGANIZACJA = 'Przyjęcie zaproszenia do zarządzania organizacją',
  BRAK_POTWIERDZENIA_W_TERMINIE_ZAPROSZENIA_DO_ZARZADZANIA_ORGANIZACJA = 'Brak potwierdzenia w terminie zaproszenia do zarządzania organizacją',
  AKTUALIZACJA_DANYCH_W_KREATORZE = 'Aktualizacja danych (po wprowadzeniu nowych danych w kreatorze)',
  PROBA_WYSZUKANIA_UZYTKOWNIKA = 'Próba wyszukania użytkownika',
  DODANIE_DO_ORGANIZACJI = 'Dodanie do organizacji',
  PRZEJECIE_ORGANIZACJI = 'Przejęcie organizacji',
  PRZEJECIE_INSTYTUCJI_ORGANIZACJI = 'Przejęcie instytucji organizacji',
}
